"use strict"; // @ts-nocheck

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @param axis
 */

function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

exports["default"] = getAltAxis;